import { yupResolver } from '@hookform/resolvers/yup'
import { EFinancingProgram } from '@if/core/types'
import { ActionsDialog, PageError } from '@src/components'
import ApplicantExpensesSection from '@src/containers/EditCreditApplicationPage/components/CreditApplicationForm/components/Applicant/components/applicantExpenseComponent'
import { useBusinessErrors } from '@src/data/selectors/app-config-selectors'
import { Applicant, DraftApplicantSchema } from '@src/data/types'
import { reportErrorToConsole } from '@src/services/error-logger'
import { memo, useCallback, useEffect } from 'react'
import { Resolver, useForm } from 'react-hook-form'

interface Props {
  applicant: Applicant | undefined
  open: boolean
  title: string
  onConfirm: (data: Applicant) => void
  onCancel: () => void
  financingProgramId: EFinancingProgram
}

const EditExpenseDialog = ({ applicant, onConfirm, onCancel, open, title, financingProgramId }: Props) => {
  const error = useBusinessErrors()
  const {
    register,
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<Applicant>({
    mode: 'onBlur',
    defaultValues: applicant,
    // Forcing type to be backward compatible with the old schema (should be removed in the future)
    resolver: yupResolver(DraftApplicantSchema()) as unknown as Resolver<Applicant, unknown, Applicant>,
  })

  useEffect(() => {
    reset(applicant)
  }, [applicant, reset])

  const handleConfirm = useCallback(
    (data: Applicant) => {
      onConfirm({
        ...data,
        expenses: {
          ...data.expenses,
          isLaw134Confirmed: true,
        },
      } as Applicant)
    },
    [onConfirm],
  )

  return (
    <ActionsDialog
      title={title}
      onCancel={onCancel}
      onConfirm={handleSubmit(handleConfirm, reportErrorToConsole)}
      open={open}
    >
      <PageError errors={error} />
      <ApplicantExpensesSection
        name="expenses"
        register={register}
        watch={watch}
        setValue={setValue}
        errors={errors.expenses}
        showDetailedForm
        financingProgramId={financingProgramId}
        editDisabled
      />
    </ActionsDialog>
  )
}
export default memo(EditExpenseDialog)
